enum FunctionalityAvailableType {
	CLAIM_VIBAN = 'CLAIM_VIBAN',
	ADD_LINKED_CARD = 'ADD_LINKED_CARD',
	ORDER_DEBIT_CARD = 'ORDER_DEBIT_CARD',
}

export default FunctionalityAvailableType;
